import type { Nullable } from 'primereact/ts-helpers';

export function goToViewCustomer(id: Nullable<number>) {
  return id ? `/main/customers/${id}/view` : '';
}

export function goToEditCustomer(id: Nullable<number>) {
  return id ? `/main/customers/${id}/edit` : '';
}

export function goToCustomerList() {
  return '/main/customers/list';
}
